module.exports = __webpack_public_path__ + "img/glogo250.54fb094e.png";